import { useQuery } from './useQuery';
import { useNavigate } from 'react-router-dom';

export const useCurrentTab = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const currentTabKey = query.get('tabKey');

  const setTabKey = (tabKey) => {
    navigate(`?tabKey=${tabKey}`);
  };

  return { currentTabKey, setTabKey };
};
